import Route from '@ember/routing/route';
import { service } from '@ember/service';
import RSVP from 'rsvp';

export default Route.extend({
  fundsService: service(),
  store: service(),

  beforeModel() {
    return this.fundsService.confirmValidFundToken();
  },

  model() {
    let user = this.modelFor('admin.users.show');
    let selectedFundId = user.selectedFundId;
    let selectedFund = null;
    if (selectedFundId) {
      selectedFund = this.store.findRecord('admin/fund', selectedFundId);
    }
    return RSVP.hash({
      user,
      selectedFund,
    });
  },
});
